import { defineComponent as _defineComponent } from 'vue'
import { ref, toRef } from '@nuxtjs/composition-api';
interface Props {
  // start open but use the default behaviour
  startOpen?: boolean;
  // use this for manual control for opening and closing the accordion
  isOpen?: boolean;
  size?: 'md' | 'lg';
  variant?: 'default' | 'wide' | 'wide-child';
  btnClass?: string;
  expandedBtnClass?: string;
  overflowHidden?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 't-accordion',
  props: {
    startOpen: { type: Boolean, default: false },
    isOpen: { type: Boolean, default: undefined },
    size: { default: 'md' },
    variant: { default: 'default' },
    btnClass: { default: '' },
    expandedBtnClass: { default: '' },
    overflowHidden: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: $emit }: { emit: ((event: 'click', isExpanded: boolean | undefined) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { startOpen: boolean, isOpen: boolean, size: 'md' | 'lg', variant: 'default' | 'wide' | 'wide-child', btnClass: string, expandedBtnClass: string, overflowHidden: boolean };


const isExpanded =
  props.isOpen === undefined ? ref(props.startOpen || false) : toRef(props, 'isOpen');

const clickEvent = (): void => {
  if (props.isOpen === undefined) {
    isExpanded.value = !isExpanded.value;
  }
  $emit('click', isExpanded.value);
};

const enter = (el: HTMLElement): void => {
  el.style.height = el.scrollHeight + 'px';
};
const beforeLeave = (el: HTMLElement): void => {
  el.style.height = el.scrollHeight + 'px';
};
const resetHeight = (el: HTMLElement): void => {
  el.style.height = '';
};



return { __sfc: true,props, isExpanded, clickEvent, enter, beforeLeave, resetHeight, $emit }
}

})